import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import { Box, Flex, Text, Checkbox, Button, Divider } from "samba-ui";
import styled from "styled-components";
import { getCriteriaByFeedType } from "../../../../utils";
import { updateFeed } from "../../../../actions/feed";
import AreYouSureModal from "../../../Common/AreYouSureModal";
import {
  Block,
  CriteriaSidePanel,
  CriteriaContainer,
  Criteria,
  CriteriaContentContainer,
} from "../styles";
import FeedInfoDetails from "../FeedInfoDetails";

const CriteriaInfo = styled.div`
  display: flex;
  flex-direction: column;
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
  opacity: : ${(p) => (p.disabled ? 0.5 : 1)};
`;

const CriteriaComponent = ({ feed, files, updateFeed }) => {
  let CRITERIAS = [...getCriteriaByFeedType(feed.type, { value: feed.country }, feed.pbse_version)]

  const [selectedCriteria, setSelectedCriteria] = useState({});
  const [originalCriteria, setOriginalCriteria] = useState({});

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!feed.cols_to_include) {
      return;
    }

    let criteriaMap = feed.cols_to_include.reduce((acc, c) => {
      acc[c] = true;
      return acc;
    }, {});
    setSelectedCriteria(criteriaMap);
    setOriginalCriteria(criteriaMap);
  }, [feed.cols_to_include]);

  const onSaveClick = () => {
    setIsOpen(false);
    const colToInclude = Object.keys(selectedCriteria).filter(
      (key) => selectedCriteria[key]
    );

    updateFeed(feed.id, { cols_to_include: JSON.stringify(colToInclude) });
  };

  const onCheckboxChange = (criteria) => {
    setSelectedCriteria({
      ...selectedCriteria,
      [criteria]: !selectedCriteria[criteria],
    });
  };

  const isDisabled = () => {
    return (
      Object.values(selectedCriteria).filter((x) => !!x).length ===
      feed.cols_to_include.length
    );
  };

  const getAreYouSureBody = () => {
    const colToInclude = Object.keys(selectedCriteria).filter(
      (key) => selectedCriteria[key]
    );

    return JSON.stringify(_.difference(colToInclude, feed.cols_to_include));
  };

  return (
    <Box>
      {feed.cols_to_include && feed.cols_to_include.length ? (
        <Block>
          <CriteriaContentContainer>
            <CriteriaSidePanel>
              <Box>
                Note: you cannot uncheck the included fields once the feed has
                started but you can check new ones.
              </Box>
            </CriteriaSidePanel>

            <CriteriaInfo disabled={feed.type === "geo weights"}>
              <Text>Columns that will appear in the file.</Text>
              <Box>
                <Divider />
              </Box>
              <CriteriaContainer>
                {CRITERIAS.map((criteria) => (
                  <Criteria key={criteria}>
                    <Checkbox
                      id={criteria}
                      disabled={originalCriteria[criteria]}
                      checked={selectedCriteria[criteria]}
                      onChange={() => onCheckboxChange(criteria)}
                    />
                    {criteria}
                  </Criteria>
                ))}
              </CriteriaContainer>
            </CriteriaInfo>
          </CriteriaContentContainer>
          <Flex
            mt={2}
            width="100%"
            alignItems="center"
            justifyContent="flex-end"
            pr={30}
          >
            <Button disabled={isDisabled()} onClick={() => setIsOpen(true)}>
              Save
            </Button>
          </Flex>
        </Block>
      ) : null}

      <FeedInfoDetails feed={feed} file={files.slice(0, 1)} />
      <AreYouSureModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={"Update Criteria"}
        body={`Are you sure you want to add the following columns ${getAreYouSureBody()}. This action will update the feed's schema.`}
        onSubmit={onSaveClick}
      />
    </Box>
  );
};

CriteriaComponent.propTypes = {
  feed: PropTypes.object,
  files: PropTypes.object,
  updateFeed: PropTypes.func,
};

export default connect(
  null,
  { updateFeed }
)(CriteriaComponent);
